<template>
  <div class="page page--fill">
    <data-list
      ref="list"
      title="Utilisateurs"
      :resource="resource"
      :columns="columns"
      :filters="filters">
      <template #summary>
        <kpi-row :items="kpis" />
      </template>
      <template #name="{ item }">
        <div class="cell-strong">
          {{ item.first_name }} {{ item.last_name }}
        </div>
        <div class="cell-muted">
          {{ item.email }}
        </div>
        <span
          v-if="item.locked"
          class="pill pill--warning mt-1">Désactivé</span>
      </template>
      <template #profil="{ item }">
        <span :class="pillClass(USER_PROFIL, item.profil)">{{ labelOf(USER_PROFIL, item.profil) }}</span>
      </template>
      <template #account="{ item }">
        <router-link
          v-if="item.account"
          class="cell-link"
          :to="{ name: 'accountVue', params: { id: item.account.pk } }">
          {{ item.account.name }}
        </router-link>
        <span v-else>—</span>
      </template>
      <template #row_actions="{ item }">
        <div
          class="row-actions"
          @click.stop>
          <v-btn
            text
            small
            color="primary"
            @click="sendActivationMail(item)">
            <v-icon
              left
              small>
              mdi-email-outline
            </v-icon>
            Mail d'activation
          </v-btn>
          <v-btn
            v-if="item.account"
            icon
            small
            title="Créer une clé d'API pour ce compte"
            @click="apiKeyAccount = item.account">
            <v-icon small>
              mdi-key-plus
            </v-icon>
          </v-btn>
          <v-btn
            v-if="item.profil !== 'superadmin'"
            icon
            small
            :title="item.locked ? 'Réactiver l\'utilisateur' : 'Désactiver l\'utilisateur'"
            @click="toggleLocked(item)">
            <v-icon small>
              {{ item.locked ? 'mdi-lock-open-variant-outline' : 'mdi-lock-outline' }}
            </v-icon>
          </v-btn>
        </div>
      </template>
    </data-list>

    <api-key-modal
      v-if="apiKeyAccount"
      :show-dialog="!!apiKeyAccount"
      :initial-account="apiKeyAccount"
      @close="apiKeyAccount = null"
      @submit="addKey" />
  </div>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import DataList from '../components/DataList'
  import KpiRow from '../components/KpiRow'
  import ApiKeyModal from '../components/ApiKeyModal'
  import { USER_PROFIL, toOptions, pillClass, labelOf, formatDate } from '../labels'

  export default {
    name: 'UserList',
    components: { DataList, KpiRow, ApiKeyModal },
    data () {
      return {
        kpis: [
          { label: 'Utilisateurs', resource: RESOURCES.USER, params: {} },
          { label: 'Admins', resource: RESOURCES.USER, params: { profil: 'admin' } },
          { label: 'Managers', resource: RESOURCES.USER, params: { profil: 'manager' } },
          { label: 'Vendeurs', resource: RESOURCES.USER, params: { profil: 'seller' } }
        ],
        USER_PROFIL,
        apiKeyAccount: null,
        resource: RESOURCES.USER,
        columns: [
          { key: 'name', label: 'Utilisateur' },
          { key: 'profil', label: 'Profil', width: 130 },
          { key: 'account', label: 'Compte' },
          { key: 'phone', label: 'Téléphone', width: 140 },
          { key: 'created_on', label: 'Créé le', width: 110, format: formatDate },
          { key: 'row_actions', label: '', width: 240, align: 'end' }
        ],
        filters: [
          { key: 'searchable_name', type: 'search', label: 'Rechercher un nom' },
          { key: 'email', type: 'search', label: 'Email', width: 220 },
          { key: 'profil', type: 'select', label: 'Profil', items: toOptions(USER_PROFIL) },
          { key: 'account', type: 'remote', label: 'Compte', resource: RESOURCES.ACCOUNT }
        ]
      }
    },
    methods: {
      pillClass,
      labelOf,
      async toggleLocked (user) {
        const name = `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email
        const ok = await this.$confirm({
          title: user.locked ? 'Réactiver l\'utilisateur ?' : 'Désactiver l\'utilisateur ?',
          message: user.locked ? `${name} pourra de nouveau se connecter.` : `${name} ne pourra plus se connecter.`,
          confirmLabel: user.locked ? 'Réactiver' : 'Désactiver',
          danger: !user.locked
        })
        if (!ok) return
        try {
          await this.$api.patch(RESOURCES.USER, user.pk, { locked: !user.locked })
          this.$awn.success(user.locked ? 'Utilisateur réactivé' : 'Utilisateur désactivé')
          this.$refs.list.reload()
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert('Impossible de modifier cet utilisateur')
        }
      },
      async addKey (payload) {
        try {
          await this.$api.axios.post('api-keys', payload)
          this.apiKeyAccount = null
          this.$awn.success('Clé créée')
          this.$router.push({ name: 'apikeys' })
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert('Impossible de créer la clé d\'API')
        }
      },
      async sendActivationMail (user) {
        try {
          await this.$api.sendUserInvitation(user.pk)
          this.$awn.success(`Mail d'activation envoyé à ${user.email}`)
        } catch (e) {
          if (e.message !== 'Action annulée') this.$awn.alert(`Échec de l'envoi à ${user.email}`)
        }
      }
    }
  }
</script>

<style scoped>
  .row-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>
